import React, { useState, useEffect, useRef } from 'react';
import { Input } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../Context';
import { VoucherFormSection } from '../Section';
import { Asterisk } from '../Asterisk';

interface VoucherFormQuantityProps {
  template?: {
    disabled?: boolean;
  };
}

const VoucherFormQuantity: React.FC<VoucherFormQuantityProps> = ({ template }) => {
  const {
    formState: {
      payload: { count },
    },
    setFormState,
  } = useVoucherFormContext();

  const [localValue, setLocalValue] = useState('');
  const previousValueRef = useRef('');

  useEffect(() => {
    setLocalValue(String(count));
  }, [count]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setLocalValue(inputValue);

    const parsedValue = parseInt(inputValue, 10);

    setFormState(prev => ({
      ...prev,
      payload: {
        ...prev.payload,
        count: isNaN(parsedValue) ? 0 : parsedValue,
      },
    }));
  };

  const handleFocus = () => {
    previousValueRef.current = localValue;
    setLocalValue('');
  };

  const handleBlur = () => {
    if (localValue.trim() === '') {
      setLocalValue(previousValueRef.current);
    }
  };

  return (
    <VoucherFormSection
      title='Voucher quantity'
      inputs={
        <Input
          disabled={template?.disabled}
          name='voucher-quantity'
          id='voucher-quantity-field'
          label={<>How many vouchers? {!template?.disabled && <Asterisk />}</>}
          type='number'
          required
          min={1}
          value={localValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      }
    />
  );
};

export default VoucherFormQuantity;
